module.exports = __webpack_public_path__ + "static/media/winterweave-4.5c38296d.jpg";